import { render, staticRenderFns } from "./InventoryItem.vue?vue&type=template&id=9b26cfbc&scoped=true"
import script from "./InventoryItem.vue?vue&type=script&lang=js"
export * from "./InventoryItem.vue?vue&type=script&lang=js"
import style0 from "./InventoryItem.vue?vue&type=style&index=0&id=9b26cfbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b26cfbc",
  null
  
)

export default component.exports